/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from "./actionTypes";

const axiosPayLoad = {
  contactTypeResults: [],
  alterApiFetchedStatus: false,
  isDataSaved: false,

  newContactTypeResult: [],
  selectedParentKey: null,
  loading: false,
  compareContactTypeResult: [],
  dataChangeTried: 0,
  errorMessage: null,
  successMessages: null,
  childContactTypeError: false,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_CONTACT_TYPE_DETAILS:
      return {
        ...state,
        contactTypeResults: action.contactTypeResults,
        alterApiFetchedStatus: !state.alterApiFetchedStatus,
      };

    case actionTypes.UPDATE_CONTACT_TYPE_DETAILS:
      return { ...state, isDataSaved: true };

    case actionTypes.RESET_SAVE_FLAG:
      return { ...state, isDataSaved: false };

    case actionTypes.GET_CONTACT_TYPE_DETAILS_NEW:
      return { ...state, newContactTypeResult: action.payload };
    case actionTypes.COMPARE_CONTACT_TYPE_DATA:
      return { ...state, compareContactTypeResult: action.payload };
    case actionTypes.CONTACT_TYPE_DETAILS_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.CONTACT_TYPE_ROW_SELECTED:
      return { ...state, selectedParentKey: action.payload };
    case actionTypes.CONTACT_TYPE_DETAILS_ERROR_MESSAGE:
      return { ...state, errorMessage: action.payload };
    case actionTypes.CONTACT_TYPE_DETAILS_SUCCESS_MESSAGE:
      return { ...state, successMessages: action.payload };
    case actionTypes.CONTACT_TYPE_DETAILS_DATA_CHANGE_TRIED:
      return { ...state, dataChangeTried: action.payload };
    case actionTypes.CHILD_CONTACT_TYPE_ERROR:
      return { ...state, childContactTypeError: action.payload };
    case actionTypes.RESET_CONTACT_TYPE_STORE:
      return { ...axiosPayLoad };
    default:
      return state;
  }
};

export default reducer;
